"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = exports.default = void 0;
var _styles = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _ProductSyles = require("react-platform-product/dist/Product/ProductSyles");
var _reactRedux = require("react-redux");
var _CreateProductSalable = _interopRequireDefault(require("./dialogs/CreateProductSalable"));
var _ProductSalableActions = require("./ProductSalableActions");
var _ProductSalableList = _interopRequireDefault(require("./ProductSalableList/ProductSalableList"));
var _ProductSalableTable = _interopRequireDefault(require("./ProductSalableTable"));
var _config = require("react-platform-product/dist/config");
var _index = require("../config/index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var defaultConfig = {
  listComponent: _index.USE_TABLE_IN_PRODUCTS_LIST ? _ProductSalableTable.default : _ProductSalableList.default,
  createComponent: _CreateProductSalable.default,
  headerTitle: 'Salable Products',
  FETCH_ACTION: _index.USE_TABLE_IN_PRODUCTS_LIST ? undefined : _ProductSalableActions.FETCH_PRODUCT_SALABLES,
  DELETE_ACTION: _ProductSalableActions.DELETE_PRODUCT_SALABLES,
  detailEndpoint: 'product-salable',
  creationType: _config.PRODUCTS_CREATION_TYPE,
  creationTypeEndpoint: _config.PRODUCTS_CREATION_ENDPOINT,
  fields: _index.PRODUCTS_LIST_FIELDS_OPTIMISATION
};

/**
 * We create out class by using injectToBaseContainer
 * this will return a React Component that is wrapped with the HOCs
 * inside flowRight, and hass all the props that are passed as options
 */
exports.defaultConfig = defaultConfig;
var _default = (0, _BaseInjectors.injectToBaseContainer)(_lodash.default.flowRight((0, _styles.withStyles)(_ProductSyles.styles), _index.USE_TABLE_IN_PRODUCTS_LIST ? undefined : (0, _reactRedux.connect)(function (state) {
  return {
    products: state.productSalableReducer.productSalables,
    pagination: state.productSalableReducer.pagination,
    inProgress: state.productSalableReducer.inProgress
  };
})), defaultConfig);
exports.default = _default;